<template>
  <div>
    <b-button @click="showForm = !showForm" :variant="pvariant">{{text}}</b-button>
    <b-modal id="modal-1" :title="text" v-model="showForm"
      size="sm"
      scrollable
      @ok="handleOk"
      @cancel="handleCancel">
      <b-row>
        <b-col>
          <b-form-group>
            <b-form-group
              label="Title"
              label-for="title-input"
              invalid-feedback="Title is required"
            >
              <b-form-input
                id="title-input"
                v-model="thisLink.title"
                required
              ></b-form-input>
            </b-form-group>
          </b-form-group>

          <b-form-group
            label="URL"
            label-for="url-input"
          >
            <b-form-input
              id="url-input"
              v-model="thisLink.link"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: [ 'link', 'text', 'pvariant' ],
  data () {
    return {
      showForm: false,
      thisLink: {
        title: '',
        link: ''
      }
    }
  },
  methods: {
    handleOk (evt) {
      evt.preventDefault()

      this.$emit('ok', this.thisLink)

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-1')
      })
    },
    handleCancel () {
      this.$emit('cancel')

      this.$nextTick(() => {
        this.$bvModal.hide('modal-1')
      })
    }
  },
  watch: {
    showForm (value) {
      if (value) {
        this.thisLink = JSON.parse(JSON.stringify(this.link))
      }
    }
  }
}
</script>

<style>

</style>
